import { isAxiosError } from 'axios'

/** GET карточки без доступа на бэке маскируется как 404 */
export function isHttpNotFound(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 404
}
